import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Box from '../Box';
import Checkbox from '../Checkbox';
import Icon from '../Icon';
import { ItemListItem } from '../ItemList';
import Menu from '../Menu';
import { OPTION_DISPLAY_NAME } from './constants';
import SelectContext from './Context';

var noop = function noop() {
  return null;
};

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "checkmark",
  size: "sm"
});

var _ref3 = /*#__PURE__*/React.createElement(Box, {
  width: 2.5,
  height: 2.5
});

var Option = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Option, _Component);

  function Option() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Option.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        index = _this$props.index,
        text = _this$props.text,
        value = _this$props.value,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "disabled", "index", "text", "value"]);

    return /*#__PURE__*/React.createElement(SelectContext.Consumer, null, function (selectContext) {
      return /*#__PURE__*/React.createElement(ItemListItem, {
        data: value,
        text: text,
        disabled: disabled,
        index: index
      }, function (_ref) {
        var clearHighlight = _ref.clearHighlight,
            highlight = _ref.highlight,
            highlighted = _ref.highlighted,
            select = _ref.select,
            selected = _ref.selected,
            id = _ref.id;
        return /*#__PURE__*/React.createElement(Menu.Item, _extends({
          id: id,
          role: "option",
          as: "li",
          "aria-disabled": disabled,
          "aria-selected": selected,
          disabled: disabled,
          isHighlighted: highlighted,
          onMouseOver: highlight,
          onMouseOut: clearHighlight,
          onMouseUp: function onMouseUp() {
            return selectContext.canSelectOption.current && select();
          },
          renderLeft: typeof children === 'function' ? null : selectContext.multiple ? /*#__PURE__*/React.createElement(Checkbox, {
            size: "sm",
            label: null,
            checked: selected,
            onChange: noop
          }) : selected ? _ref2 : _ref3
        }, restProps), typeof children === 'function' ? children(selected) : children);
      });
    });
  };

  return Option;
}(Component);

_defineProperty(Option, "displayName", OPTION_DISPLAY_NAME);

export default Option;